import { ChangelogItemProvider } from "./changelog-item-context";
import CommentSection from "./CommentSection";
import EventContent from "./EventContent";
import EventHeader from "./EventHeader";
import TimelineIcon from "./TimelineIcon";

import { ChangelogEntry } from "@/queries/folder-entities/types";

interface ChangelogItemProps {
  event: ChangelogEntry;
  isLast: boolean;
}

const ChangelogItem = ({ event, isLast }: ChangelogItemProps) => (
  <ChangelogItemProvider event={event}>
    <div className="relative">
      {!isLast && <div className="absolute left-[15px] top-10 h-full w-px bg-gray-200" />}

      <div className="flex gap-4">
        <TimelineIcon actionType={event.action_type} />

        <div className="mb-2 flex-1 rounded-lg border bg-white p-4">
          <EventHeader />
          <EventContent />
          <CommentSection />
        </div>
      </div>
    </div>
  </ChangelogItemProvider>
);

export default ChangelogItem;
